module.exports = __webpack_public_path__ + "img/1440.e68d7f7e.jpg";